import React from "react";
import { Button } from "@/components/ui/button";
import { SavedSshKey } from "@/types/savedSshKey";

type SshKeyListItemProps = {
  sshKey: SavedSshKey;
  onDelete: (id: string) => void;
  leading?: React.ReactNode;
};

export const SshKeyListItem: React.FC<SshKeyListItemProps> = ({ sshKey, onDelete, leading }) => {
  const created = new Date(sshKey.createdAt);
  const createdLabel = Number.isNaN(created.getTime())
    ? ""
    : created.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric"
      });

  return (
    <div className="flex items-center gap-3 rounded-lg border border-border bg-background px-4 py-3">
      {leading}
      <div className="min-w-0 flex-1">
        <div className="text-sm font-medium text-foreground">{sshKey.name}</div>
        <div className="truncate font-mono text-xs text-muted-foreground">{sshKey.fingerprint}</div>
      </div>
      {createdLabel ? (
        <div className="hidden shrink-0 text-sm text-muted-foreground sm:block">{createdLabel}</div>
      ) : null}
      <Button
        type="button"
        variant="error"
        size="xs"
        className="shrink-0"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onDelete(sshKey.id);
        }}
      >
        Delete
      </Button>
    </div>
  );
};
